/* RESPONSIBLE TEAM: team-phone */

export type FinVoiceVoiceLanguageOptions = {
  value: FinVoiceVoiceLanguage;
  text: string;
};

export type FinVoiceVoiceLanguage = 'en-US' | 'es-ES' | 'fr-FR';

export const FIN_VOICE_VOICE_LANGUAGE_OPTIONS: FinVoiceVoiceLanguageOptions[] = [
  { value: 'en-US', text: 'app.lib.languages.language.en' },
  { value: 'es-ES', text: 'app.lib.languages.language.es' },
];

export const DEFAULT_VOICE_LANGUAGE = 'en-US';
